import React, { useState, useEffect } from 'react'
import styles from './styles.module.css'
import { getCurrentYearUtils } from '../../utils/classBook'
import { useDispatch, useSelector } from 'react-redux'
import { getSchoolYears } from '../../actions/common'
import { getStudyPeriod } from '../../actions/classbook'
import {
    getThemePlanningTeachers,
    getThemePlanningCourses,
    getThemePlanningWeeks,
    getThemePlanningLesson,
    clearThemePlanningLesson,
    clearThemePlanning
} from '../../actions/planning'
import SearchPanel from './SearchPanel'
import Table from './Table'
import Modal from './modal'

const ThematicPlanning = () => {

    const [formData, setFormData] = useState({
        class: '',
        scYear: '',
        week: '',
        teacher: '',
        lesson: '',
        studyPeriod: '',
        type: 0
    });

    const [modalOpen, setModalOpen] = useState(false);
    const [selectedLesson, setSelectedLesson] = useState(null);

    const dispatch = useDispatch();

    const { schoolYears } = useSelector(state => state.common);
    const { teachers = [], courses = [], weeks = [] } = useSelector(state => state.planning);
    const { studyPeriod } = useSelector(state => state.classbook);

    const weekNowToPast = [...weeks].reverse();

    useEffect(() => {
        dispatch(getSchoolYears());
        return () => {
            dispatch(clearThemePlanning());
        }
    }, [])

    useEffect(() => {
        const currYear = getCurrentYearUtils(schoolYears)
        setFormData(prev => ({ ...prev, scYear: currYear }))
    }, [schoolYears])

    useEffect(() => {
        if (formData.scYear) {
            // dispatch(getStudyPeriod({ scYear: formData.scYear }))
            dispatch(getThemePlanningWeeks(formData.scYear))
        }
    }, [formData.scYear])

    useEffect(() => {
        if (formData.week) {
            dispatch(getThemePlanningTeachers(formData.week, formData.type));
        }
    }, [formData.week])

    useEffect(() => {
        if (formData.teacher && formData.week) {
            dispatch(getThemePlanningCourses(formData.teacher, formData.week, formData.type));
        }
    }, [formData.teacher, formData.week])

    const handleInputChange = (e) => {
        const { name, value } = e.target

        setFormData(prev => {
            const newData = { ...prev, [name]: value }

            // Сброс зависимых селектов
            if (name === 'scYear') {
                newData.studyPeriod = ''
                newData.week = ''
                newData.teacher = ''
                newData.lesson = ''
            } else if (name === 'studyPeriod') {
                newData.week = ''
                newData.teacher = ''
                newData.lesson = ''
            } else if (name === 'week') {
                newData.teacher = ''
                newData.lesson = ''
            } else if (name === 'teacher') {
                newData.lesson = ''
            }

            return newData
        })
    }

    const openModal = (item) => {
        setSelectedLesson(item);
        if (item?.sheid && item?.week_id) {
            dispatch(getThemePlanningLesson(item.sheid, item.week_id, formData.type));
        }
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setSelectedLesson(null);
        dispatch(clearThemePlanningLesson());
    };

    const handleSubmit = () => {
        closeModal();
    }

    return (
        <div className={styles.wrapper}>
            <h1>Тематическое планирование</h1>

            <SearchPanel
                lessons={courses}
                formData={formData}
                teachers={teachers}
                schoolYears={schoolYears}
                studyPeriod={studyPeriod}
                setFormData={setFormData}
                weekNowToPast={weekNowToPast}
                handleInputChange={handleInputChange}
            />

            <Table
                modalOpen={openModal}
                formData={formData}
            />

            <Modal
                isOpen={modalOpen}
                closeModal={closeModal}
                handleSubmit={handleSubmit}
                selectedLesson={selectedLesson}
                formData={formData}
            />

        </div>
    )
}

export default ThematicPlanning
